import store from "../store";
import { getAPI, axiosBase } from "./axios-base";
import axios from "axios";

const getFormdata = (body, field, deletable) => {
  let formdata = new FormData();
  if (typeof body[field] !== "object") {
    if (!body[field] && deletable) {
      formdata.append(field, "");
    }
    delete body[field];
  }
  Object.entries(body).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formdata.append(key, value);
    }
  });
  return formdata;
};

export function postLevels(body) {
  return getAPI.post("/api/levels/", body);
}
export function getLevels(params) {
  return getAPI.get("/api/levels/", { params });
}

export function getLevelById(uuid) {
  return getAPI.get(`/api/levels/${uuid}/`);
}

export function getModules(params) {
  return getAPI.get("/api/modules/", { params });
}

export function getModuleById(uuid) {
  return getAPI.get(`/api/modules/${uuid}/`);
}
export function postModules(body) {
  const formdata = getFormdata(body, "image");
  return getAPI.post("/api/modules/", formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function getLessons(params) {
  return getAPI.get("/api/lessons/", { params });
}

export function getLessonsById(uuid) {
  return getAPI.get(`/api/lessons/${uuid}/`);
}

export function postLessons(body) {
  return getAPI.post("/api/lessons/", body);
}
export function getGrammars(params) {
  return getAPI.get("/api/grammar/grammars/", { params });
}
export function getPractices(params) {
  return getAPI.get("/api/practice/practices/", { params });
}
export function getTeacherLessons(params) {
  return getAPI.get("/api/teach/teacherlessons/", { params });
}
export function getStudents(params) {
  return getAPI.get("/api/students/", { params });
}

export function getStudentById(uuid) {
  return getAPI.get(`/api/students/${uuid}/`);
}

export function postStudents(body) {
  let formdata = getFormdata(body, "avatar");
  formdata.append("role", "Student");
  return getAPI.post("/api/students/", formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function postStudentsJson(body) {
  return getAPI.post("/api/students/", body);
}
export function getTeachers(params) {
  return getAPI.get("/api/teachers/", { params });
}
export function postTeachers(body) {
  let formdata = getFormdata(body, "avatar");
  formdata.append("role", "Teacher");
  return getAPI.post("/api/teachers/", formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
export function patchTeacher({ uuid, body }) {
  return getAPI.patch(`/api/teachers/${uuid}/`, body);
}

export function changeTeacherEmail(uuid, email) {
  return getAPI.patch(`/api/teachers/${uuid}/`, { email });
}

export function getTeacherLesson(uuid) {
  return getAPI.get(`/api/teach/teacherlessons/${uuid}/`);
}
export function getPractice(uuid) {
  return getAPI.get(`/api/practice/practices/${uuid}/`);
}
export function getGrammar(uuid) {
  return getAPI.get(`/api/grammar/grammars/${uuid}/`);
}

export function postTeacherLesson(uuid) {
  return getAPI.post("/api/teach/teacherlessons/", { lesson: uuid });
}

export function postPractices(uuid) {
  return getAPI.post("/api/practice/practices/", { lesson: uuid });
}

export function postGrammars(uuid) {
  return getAPI.post("/api/grammar/grammars/", { lesson: uuid });
}

export function postLessonIntro(body) {
  let formdata = getFormdata(body, "lesson_file", true);
  if (body.uuid) return getAPI.put(`/api/teach/intro_step/${body.uuid}/`, formdata);
  else {
    return getAPI.post("/api/teach/intro_step/", formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export function getLessonIntro(uuid) {
  return getAPI.get(`/api/teach/intro_step/${uuid}/`);
}

export function postVocabulary(body) {
  let formdata = getFormdata(body, "lesson_file", true);
  let direction;
  if (body.practice) {
    direction = "practice";
  } else direction = "teach";

  if (body.uuid)
    return getAPI.put(`/api/${direction}/vocabulary_step/${body.uuid}/`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  else {
    return getAPI.post(`/api/${direction}/vocabulary_step/`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export function getVocabulary(uuid, direction) {
  return getAPI.get(`/api/${direction}/vocabulary_step/${uuid}/`);
}

export function createAudioText(uuid, direction) {
  if (direction === "practice") {
    return getAPI.post(`/api/${direction}/audiotext_step/`, {
      practice: uuid,
    });
  }
  return getAPI.post(`/api/${direction}/audiotext_step/`, {
    teacher_lesson: uuid,
  });
}

export async function postComprehension(body, direction) {
  if (body.uuid) {
    return getAPI.patch(`/api/${direction}/comprehension/${body.uuid}/`, body);
  } else {
    return getAPI.post(`/api/${direction}/comprehension/`, body);
  }
}

export function postAudioText(body, direction) {
  let formdata = getFormdata(body, "audio_file", true);
  if (body.uuid)
    return getAPI.patch(`/api/${direction}/audiotext/${body.uuid}/`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  else {
    return getAPI.post(`/api/${direction}/audiotext/`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export function getAudioText(uuid, direction) {
  return getAPI.get(`/api/${direction}/audiotext_step/${uuid}/`);
}

export function postLessonAudioTranscript(body) {
  let formdata = getFormdata(body, "lesson_file", true);
  if (body.uuid)
    return getAPI.put(`/api/teach/transcript_step/${body.uuid}/`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  else {
    return getAPI.post("/api/teach/transcript_step/", formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export function getLessonAudioTranscript(uuid) {
  return getAPI.get(`/api/teach/transcript_step/${uuid}/`);
}

export function createLessonGrammarIntro(uuid) {
  return getAPI.post("/api/teach/grammar_step/", { teacher_lesson: uuid });
}

export function getLessonGrammarIntro(uuid) {
  return getAPI.get("/api/teach/grammar_intro/", {
    params: {
      grammar_step__uuid: uuid,
    },
  });
}

export function postLessonGrammarIntro(body) {
  let formdata = getFormdata(body, "lesson_file", true);
  if (body.uuid) {
    return getAPI.patch(`/api/teach/grammar_intro/${body.uuid}/`, formdata);
  }
  return getAPI.post("/api/teach/grammar_intro/", formdata);
}

export function getLessonGrammar(uuid) {
  return getAPI.get(`/api/teach/grammar_step/${uuid}/`);
}

export async function postSpeaking(body, direction) {
  let response;
  if (body.uuid) {
    delete body.question_group;
    response = await getAPI.patch(`/api/${direction}/speak/${body.uuid}/`, body);
  } else {
    response = await getAPI.post(`/api/${direction}/speak/`, body);
  }

  return response;
}

export function newSpeaking(uuid, direction) {
  if (direction === "practice") {
    return getAPI.post(`/api/${direction}/speaking_step/`, {
      practice: uuid,
    });
  }
  return getAPI.post(`/api/${direction}/speaking_step/`, {
    teacher_lesson: uuid,
  });
}

export function postConclusion(uuid, direction) {
  if (direction === "practice") {
    return getAPI.post(`/api/${direction}/conclusion_step/`, {
      practice: uuid,
    });
  }
  return getAPI.post(`/api/${direction}/conclusion_step/`, {
    teacher_lesson: uuid,
  });
}

export function getConclusion(uuid, direction) {
  return getAPI.get(`/api/${direction}/conclusion_step/${uuid}/`);
}

export function patchLesson(uuid, body) {
  return getAPI.patch(`/api/lessons/${uuid}/`, body);
}

export function fetchCommentGroup(params) {
  return getAPI.get("/api/comments/", { params });
}
export function postComment(body) {
  let formdata = new FormData();
  if (!body.audio_file) {
    delete body.audio_file;
  }
  Object.entries(body).forEach(([key, value]) => {
    if (key === "audio_file") {
      formdata.append(key, value, "comment.webm");
    } else formdata.append(key, value);
  });
  return getAPI.post("/api/comments/", formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function getQuestionGroupById(uuid) {
  return getAPI.get(`/api/group/question/${uuid}/`);
}

export async function postQuestions(question_group) {
  const questions = question_group.questions;

  // Process all questions in parallel
  const questionPromises = questions.map(async (element) => {
    let formdata = new FormData();
    Object.entries(element).forEach(([key, value]) => {
      const includesKey = ["question_file", "question_doc_file"].includes(key);
      if (includesKey && value && typeof value === "object") {
        formdata.append(key, value);
      } else if (!includesKey) formdata.append(key, value);
    });

    if (element.uuid) {
      const response = await getAPI.patch(`/api/questions/${element.uuid}/`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } else {
      formdata.append("question_group", question_group.uuid);
      const response = await getAPI.post("/api/questions/", formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    }
  });

  // Wait for all questions to be processed
  const newQuestions = await Promise.all(questionPromises);

  const newResponse = JSON.parse(JSON.stringify(question_group));
  newResponse.questions = newQuestions;
  return newResponse;
}

export function deleteQuestion(uuid) {
  return getAPI.delete(`/api/questions/${uuid}/`);
}

export function deleteGrammarExercise(body, direction) {
  return getAPI.delete(`/api/${direction}/exercises/${body.uuid}/`);
}

export function postExercise(body) {
  let direction = "";
  if (body.grammar_step) {
    direction = "teach";
  } else direction = "grammar";
  if (body.uuid) {
    if (body.question_group) {
      delete body.question_group;
    }
    return getAPI.patch(`/api/${direction}/exercises/${body.uuid}/`, body);
  }
  return getAPI.post(`/api/${direction}/exercises/`, body);
}

export function postPracticeAudioTranscript(body) {
  let formdata = getFormdata(body, "audio_file", true);
  if (body.uuid)
    return getAPI.put(`/api/practice/transcript_step/${body.uuid}/`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  else {
    return getAPI.post("/api/practice/transcript_step/", formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}
export function getPracticeAudioTranscript(uuid) {
  return getAPI.get(`/api/practice/transcript_step/${uuid}/`);
}

export function getPronunciation(uuid) {
  return getAPI.get(`/api/practice/pronunciation_step/${uuid}/`);
}
export function postPronunciation(body) {
  if (body.question_group) {
    delete body.question_group;
  }
  if (body.uuid) {
    return getAPI.patch(`/api/practice/pronunciation_step/${body.uuid}/`, body);
  }
  return getAPI.post(`/api/practice/pronunciation_step/`, body);
}

export function getSpeaking(uuid, direction) {
  return getAPI.get(`/api/${direction}/speaking_step/${uuid}/`);
}

export function deleteSpeaking(uuid, direction) {
  return getAPI.delete(`/api/${direction}/speak/${uuid}/`);
}

export function createOrUpdateHomework(body) {
  if (body.question_group) {
    delete body.question_group;
  }
  if (body.uuid) {
    return getAPI.patch(`/api/teach/homeworks/${body.uuid}/`, body);
  } else {
    return getAPI.post("/api/teach/homeworks/", body);
  }
}

export function getHomeworks(params) {
  return getAPI.get(`/api/teach/homeworks/`, { params });
}

export function getHomeworkById(uuid) {
  return getAPI.get(`/api/teach/homeworks/${uuid}/`);
}

export function deleteHomework(uuid) {
  return getAPI.delete(`/api/teach/homeworks/${uuid}/`);
}

export function assignHomework(body) {
  return getAPI.post("/api/student-homeworks/", body);
}

export function postMessage(body) {
  return getAPI.post("/api/messages/", body);
}

export function patchReady(value, target, uuid) {
  return getAPI.patch(`/api/${target}/${uuid}/`, {
    ready: value,
  });
}
export function getAnswer(params) {
  return getAPI.get("/api/answers/", { params });
}

export function postAnswer(body) {
  let formdata = new FormData();

  if (body.audio_file === null) {
    delete body.audio_file;
  }

  Object.entries(body).forEach(([key, value]) => {
    if (key === "audio_file") {
      formdata.append(key, value, "speaking.webm");
    } else formdata.append(key, value);
  });

  if (body.uuid) {
    return getAPI.patch(`/api/answers/${body.uuid}/`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  return getAPI.post("/api/answers/", formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function getQualification(params) {
  return getAPI.get("/api/qualifications/", { params });
}
export function postQualification(body) {
  if (body.uuid) {
    return getAPI.patch(`/api/qualifications/${body.uuid}/`, body);
  }
  return getAPI.post("/api/qualifications/", body);
}

export function patchStudent(body) {
  return getAPI.patch(`/api/students/${body.uuid}/`, body);
}

export function changeStudentEmail(uuid, email) {
  return getAPI.patch(`/api/students/${uuid}/`, { email });
}

export function changeStudentPassword(uuid, password) {
  return getAPI.patch(`/api/students/${uuid}/`, { password });
}

export function getModuleProgress(params) {
  return getAPI.get("/api/progress/modules/", { params });
}

export function postModuleProgress({ module__uuid, student__email }) {
  return getAPI.post("/api/progress/modules/", {
    module: module__uuid,
    student: student__email,
    completed: false,
  });
}
export function patchModuleProgress(body) {
  return getAPI.patch(`/api/progress/modules/${body.uuid}/`, body);
}

export function getLessonProgress(params) {
  return getAPI.get("/api/progress/lessons/", { params });
}

export function postLessonProgress(body) {
  return getAPI.post("/api/progress/lessons/", body);
}

export function getLessonProgressById(uuid) {
  return getAPI.get(`/api/progress/lessons/${uuid}/`);
}

export function patchLessonProgress(body) {
  Object.entries(body).forEach(([key, value]) => {
    if (value === null) {
      delete body[key];
    }
  });
  return getAPI.patch(`/api/progress/lessons/${body.uuid}/`, body);
}

export function restartProgress(direction, body) {
  return getAPI.post(`/api/progress/reset/${direction}/`, body);
}

export function forgotPassword(email) {
  return axiosBase.post("/api/password/reset/", {
    email,
  });
}
export function recoverPassword(body) {
  return axiosBase.post(`/api/password/reset/confirm/`, body);
}

export function getProfiles(params) {
  return getAPI.get("/api/profiles/", { params });
}

export function patchProfile(body) {
  let formdata = getFormdata(body, "avatar");

  return getAPI.patch(`/api/profiles/${body.uuid}/`, formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function changePassword(body) {
  return getAPI.post("/api/myprofile/password/change/", body);
}

export function removeStudent(uuid) {
  return getAPI.delete(`/api/students/${uuid}/`);
}

export function removeTeacher(uuid) {
  return getAPI.delete(`/api/teachers/${uuid}/`);
}

export function removeLevel(uuid) {
  return getAPI.delete(`/api/levels/${uuid}/`);
}

export function removeModule(uuid) {
  return getAPI.delete(`/api/modules/${uuid}/`);
}

export function removeLesson(uuid) {
  return getAPI.delete(`/api/lessons/${uuid}/`);
}

export function getVersion() {
  return axiosBase.get("/api/release-version/");
}
export function patchModule(body) {
  let formdata = getFormdata(body, "image");
  return getAPI.patch(`/api/modules/${body.uuid}/`, formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
export function patchLevel(body) {
  return getAPI.patch(`/api/levels/${body.uuid}/`, body);
}
export function deleteComment(uuid) {
  return getAPI.delete(`/api/comments/${uuid}/`);
}

export function getModuleWithProgress(params) {
  return getAPI.get("/api/modules-with-progress/", { params });
}

export function requestRevision(body) {
  return getAPI.post("/api/progress/check_me/", body);
}

export function getAudio(url) {
  return axios.get(url, {
    responseType: "blob",
    baseURL: "",
  });
}

export function createPotentialUser(body) {
  return axios.post("/api/potential-user/", body, {
    baseURL: process.env.VUE_APP_BASE_URL,
  });
}

export function getPotentialUsers(params) {
  return getAPI.get("/api/potential-user-list/", { params });
}

export async function getFolderData(folder, level) {
  if (folder) {
    const response = await getAPI.get(`/api/dir/folders/${folder}/`);
    return {
      name: response.data.name,
      data: [
        ...response.data.subfolders.map((i) => ({
          name: i.name,
          uuid: i.uuid,
          type: "FOLDER",
        })),
        ...response.data.files.map((i) => ({
          name: i.name,
          ext: i.extension,
          type: "FILE",
          uuid: i.uuid,
          archive: i.archive,
        })),
      ],
    };
  } else {
    const response = await getAPI.get("/api/dir/folders/", {
      params: {
        level__isnull: level === null,
        level__uuid: level,
        limit: 100,
      },
    });
    const folders = [];

    for (let index = 0; index < response.data.results.length; index++) {
      const element = response.data.results[index];
      folders.push({
        name: element.name,
        uuid: element.uuid,
        type: "FOLDER",
      });
    }

    return { name: "Select a folder", data: folders };
  }
}

export async function createFile(body) {
  const formdata = getFormdata(body, "archive");
  return getAPI.post("/api/dir/files/", formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export async function createFolder(body) {
  return getAPI.post("/api/dir/folders/", body);
}

export async function updateCloudAddress(address, newName) {
  const url = address.type === "FOLDER" ? "folders" : "files";
  return getAPI.patch(`/api/dir/${url}/${address.uuid}/`, { name: newName });
}

export async function deleteCloudAddress(address) {
  const url = address.type === "FOLDER" ? "folders" : "files";
  return getAPI.delete(`/api/dir/${url}/${address.uuid}/`);
}

export async function loadFolderPermissions(folder) {
  const response = await getAPI.get("/api/dir/permissions/", {
    params: {
      folders__uuid: folder,
    },
  });
  if (response.data.results.length) return response.data.results[0];
  return null;
}

export async function createOrUpdatePermission(body) {
  if (body.uuid) return getAPI.patch(`/api/dir/permissions/${body.uuid}/`, body);
  return getAPI.post("/api/dir/permissions/", body);
}

export async function resetStepProgress(stepUuid, stepType) {
  return getAPI.post("/api/progress/reset/step/", {
    student:
      store.state.profile.role === "STUDENT"
        ? store.getters.profile.email
        : store.getters.student.email,
    step_uuid: stepUuid,
    step_type: stepType,
  });
}

export async function getStudentProgress(studentUuid) {
  return getAPI.get(`/api/progress/save/step/${studentUuid}/`);
}

export async function saveStudentProgress(body) {
  return getAPI.post("/api/progress/save/step/", body);
}

export async function listStudentTasks(params = {}) {
  return getAPI.get("/api/tasks/", { params });
}

export async function createStudentTask(body) {
  return getAPI.post("/api/tasks/", body);
}
